/**
 * --------------------------------------------------
 * components/Sitefooter.ts
 * Global Site Footer
 *
 * Example
 * <site-footer>
 *      Site footer content here
 * </site-footer>
 * --------------------------------------------------
*/

import { Component, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
import { debounce } from 'lodash';

@Component
export class SiteFooter extends ThemeComponent {
    @Ref toggle!: HTMLElement[];

    /**
     * Initialise
     */
    init() {
        this.$log.info('test footer');
        this.setEventListeners();
        this.handleResize();
    }

    setEventListeners() {
        for (const toggle of this.toggle) {
            this.$listen(toggle, 'click', () => {
                const parent = toggle.parentElement;
                const content = parent?.querySelector('[data-content]');

                if (window.innerWidth < 1025) {
                    parent?.classList.toggle('is-active');

                    if (parent?.classList.contains('is-active')) {
                        content?.setAttribute('aria-expanded', 'true');
                        return;
                    }

                    content?.setAttribute('aria-expanded', 'false');
                }
            });
        }

        window.addEventListener('resize',
            debounce(() => {
                this.handleResize();
            }, 300)
        );
    }

    handleResize() {
        for (const toggle of this.toggle) {
            const parent = toggle.parentElement;
            const content = parent?.querySelector('[data-content]');

            if (window.innerWidth < 1025) {
                toggle.setAttribute('role', 'button');
                content?.setAttribute('aria-expanded', 'false');
            } else {
                toggle.removeAttribute('role');
                content?.removeAttribute('aria-expanded');
            }
        }
    }
}
